"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M19 1a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1V2a1 1 0 011-1h18zm-1 4H2v12h16V5zm-3-3h-2v2h2V2zm3 0h-2v2h2V2z"];
//# sourceMappingURL=modal.js.map